import ErrorBoundaryComponent from './ErrorBoundary';

export default ErrorBoundaryComponent;
